import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {TramitesModule} from "../../../users/tramites/tramites.module";
import {TramiteItem} from "../../../users/tramites/components/interfaces/tramites.interface";
import {TramiteService} from "../../../users/tramites/services/tramite.service";
import {PrimeNgModule} from "../../prime-ng/prime-ng.module";
import {TramiteStatsInterface} from "../../interfaces/tramites-estadisticas";
import {ListboxModule} from "primeng/listbox";

@Component({
    selector: 'app-requisitos-informacion',
    standalone: true,
    imports: [
        TramitesModule,
        PrimeNgModule,
        ListboxModule
    ],
    templateUrl: './requisitos-informacion.component.html',
    styleUrl: './requisitos-informacion.component.scss'
})
export class RequisitosInformacionComponent implements OnInit {

    @Input() public tramites: TramiteItem | null = null;
    @Input() public estadisticas: TramiteStatsInterface = {
        idTramite: 0, idSolicitud: 0, idProyecto: 0, nombreTramite: ''
        , stats: {qtycumplidos: 0, qtyrequeridos: 0}, requisitos: []
    };
    @Output() openDialogEvent = new EventEmitter<TramiteStatsInterface>();

    constructor(protected tramite: TramiteService) {

    }

    ngOnInit() {
    }

    openDialog() {
        this.openDialogEvent.emit(this.estadisticas);
    }

    generarInfoCantidades() {
        let total = this.estadisticas.stats?.qtyrequeridos;
        let completed = this.estadisticas.stats?.qtycumplidos;
        return `${completed} / ${total}`;
    }
}
